<script setup>
import { swalError, swalSuccess } from '@/helper';
import { retrieve_child_meta } from '@/services/child';
import { add_child_meta } from '@/services/child';
import { onMounted, ref } from 'vue';

const props = defineProps({
  child_id: {
    required: true
  }
})

const isLoading = ref(true)
const child = ref({})
onMounted(async()=>{
  await get_extra_trait()
  isLoading.value = false
})

async function get_extra_trait(){
  let response = await retrieve_child_meta(props.child_id, 'key=extra_trait')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data.data){
    extraTrait.value = response.result.data.data.attributes.value
  }
}

const extraTrait = ref('')
async function addExtraTrait(){
  let meta = {
    key: 'extra_trait',
    value: extraTrait.value
  }
  let response = await add_child_meta(props.child_id, meta)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess()
}
</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <h5 class="m-0">Child Setting</h5>
    </div>
    <div class="card-body pt-0">
      <form @submit.prevent="addExtraTrait()" class="row">
        <div class="col-3 d-flex align-items-center">
          <p>Extra Trait : </p>
        </div>
        <div class="col-5">
          <input type="number" 
            class="form-control" 
            v-model="extraTrait"
            placeholder="Number of extra trait"
          >
        </div>
        <div class="col-2">
          <button type="submit" class="btn btn-light-success">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>